module.exports = __webpack_public_path__ + "fonts/pacifico.6b6170fe.ttf";